import { DecodeUriSpacesPipe } from './decode-uri-spaces.pipe';
import { NgModule } from '@angular/core';

@NgModule({
    declarations: [DecodeUriSpacesPipe],
    exports: [DecodeUriSpacesPipe]
})
export class DecodeUriSpacesModule {}
